<template>
    <div
    align="center"
    class="bg fill-height mt-6"
  >
    <v-container
      fluid
    >
      <html><head><meta http-equiv="Content-Type" content="text/html;charset=utf-8" /><link href="style.css" rel="stylesheet" type="text/css" /><title>Unknown</title></head><body><div class="calibre" id="calibre_link-0">
	<p align="left"  class="block_">TERMO DE CREDENCIAMENTO À REDE DE OPERADORES DE DRONE DA PLATAFORMA MAPPA</p>
	<p class="block_1">&nbsp;</p>
	<p class="block_2">&nbsp;</p>
	<p class="block_3"><b class="calibre1">CONSIDERANDO </b>que,<b class="calibre1"> </b></p>
	<p class="block_4">&nbsp;</p>
	<ol class="list_">
	<li class="block_5"><b class="calibre1">HORUS</b> é empresa voltada à fabricação e comercialização de veículos aéreos não tripulados, denominados VANT’s;</li>
	<li class="block_6">Além disso, presta serviços de processamento de ortomosaicos usando, para tanto, a ferramenta denominada “Mappa”;</li>
	<li class="block_6">Considerando, ainda, que para que o processamento seja possível, é necessário que anteriormente ocorra a captação das imagens aéreas;</li>
	<li class="block_7">E considerando, por fim, que o <b class="calibre1">CREDENCIADO</b> dispõe dos equipamentos, bem como reúne a expertise e conhecimento técnico necessários à captação das imagens;</li>
</ol>
	<p class="block_8"><b class="calibre2">1.</b> O ora <b class="calibre2">CREDENCIADO</b>, ao aceitar as disposições deste Termo de Credenciamento, passa a integrar a Rede Mappa, declarando verdadeiras todas as informações prestadas e submetendo-se a todas as regras deste instrumento. </p>
	<p class="block_4">&nbsp;</p>
	<p class="block_3"><b class="calibre1">2.</b> A Rede Mappa é composta pelos credenciados que tenham interesse em prestar serviços de mapeamento aéreo em suas respectivas regiões por determinação de <b class="calibre1">HÓRUS AERONAVES LTDA. - EPP</b>, pessoa jurídica de direito privado, inscrita no CNPJ/MF sob o n° 19.664.563/0001-02, sendo esta a responsável pelo processamento dos ortomosaicos, o qual será realizado por meio da ferramenta Mappa.</p>
	<p class="block_4">&nbsp;</p>
	<p class="block_3"><b class="calibre1">3.</b> Assim, por ter declarado interesse em integrar a Rede Mappa, o <b class="calibre1">CREDENCIADO,</b> a partir do aceite deste Termo, fica à disposição da <b class="calibre1">HORUS </b>respeitadas as condições e demais disposições ajustadas neste instrumento. </p>
	<p class="block_4">&nbsp;</p>
	<p class="block_3"><b class="calibre1">4.</b> Os serviços a serem prestados pelo credenciado serão executados mediante a orientação direta e expressa de <b class="calibre1">HÓRUS</b>. Para tanto, declara o <b class="calibre1">CREDENCIADO</b> que dispõe dos equipamentos necessários, bem como reúne a expertise e conhecimento técnico para concluir os serviços com excelência no prazo acordado.</p>
	<p class="block_4">&nbsp;</p>
	<p class="block_3"><b class="calibre1">5.</b> Compromete-se o <b class="calibre1">CREDENCIADO</b>, sem prejuízo de outras obrigações previstas na legislação aplicável e neste Termo a:</p>
	<p class="block_4">&nbsp;</p>
	<div class="calibre3">
	<div class="block_9"><span class="bullet_">a)&nbsp;</span><span class="calibre4">Executar os serviços objeto deste Termo na melhor forma técnica e em conformidade com as especificações, prazos e padrões acordados com a <b class="calibre1">HORUS</b>;</span></div>
	<div class="block_9"><span class="bullet_">b)&nbsp;</span><span class="calibre4">Recolher todos os tributos, diretos e indiretos, que eventualmente lhe corresponderem, resultantes da prestação dos serviços objeto deste Contrato;</span></div>
	<div class="block_9"><span class="bullet_">c)&nbsp;</span><span class="calibre4">Refazer os trabalhos sempre que <b class="calibre1">HORUS </b>identificar, a seu critério, baixa qualidade ou outros problemas decorrentes da captação das imagens; </span></div>
	<div class="block_9"><span class="bullet_">d)&nbsp;</span><span class="calibre4">Assumir integral e exclusiva responsabilidade por toda e qualquer eventual reclamação trabalhista que vier a ser proposta em face da <b class="calibre1">HORUS</b>, por funcionário(s) ou preposto(s) do <b class="calibre1">CREDENCIADO</b>, em função dos serviços prestados, objeto deste Termo;</span></div>
	<div class="block_9"><span class="bullet_">e)&nbsp;</span><span class="calibre4">Reconhecer, expressamente, que a execução dos serviços ora ajustados não estabelece nenhum vínculo empregatício de responsabilidade da <b class="calibre1">HORUS</b> com relação ao <b class="calibre1">CREDENCIADO</b> no que tange à execução dos serviços, uma vez que a relação estabelecida é unicamente de prestação de serviços;</span></div>
	<div class="block_9"><span class="bullet_">f)&nbsp;</span><span class="calibre4">Não revelar, sob hipótese alguma, quaisquer informações, dados técnicos ou não, métodos de organização, normas comerciais ou quaisquer documentos, dados e informações da <b class="calibre1">HORUS</b>, empresas controladas, controladoras ou coligadas, bem como de seus clientes que vier a ter conhecimento no exercício de suas atribuições, sob pena de responsabilização civil e criminal, perdurando tal obrigação mesmo após o término do presente contrato;</span></div>
	<div class="block_10"><span class="bullet_">g)&nbsp;</span><span class="calibre4">Prestar os serviços por sua própria conta e risco, eximindo a<b class="calibre1"> HORUS </b>de quaisquer ônus, multas, infrações e/ou encargos decorrentes e responsabilizando-se por quaisquer danos ocasionados, culposa ou dolosamente, à <b class="calibre1">HORUS</b>, seus clientes<b class="calibre1"> </b>e/ou terceiros. </span></div>
</div>
	<p class="block_3"><b class="calibre1">6.</b> Fica expressamente reconhecido pelo <b class="calibre1">CREDENCIADO</b> que a adesão à Rede Mappa gera mera expectativa de contratação, não havendo, por parte da <b class="calibre1">HORUS</b>, qualquer obrigação em contratar, a qualquer tempo ou em qualquer periodicidade, os serviços do <b class="calibre1">CREDENCIADO</b>. </p>
	<p class="block_4">&nbsp;</p>
	<p class="block_3"><b class="calibre1">7.</b> O <b class="calibre1">CREDENCIADO</b> será responsável por todos e quaisquer danos diretos ou indiretos, lucros cessantes, interrupção de negócios, ou perda de informações, para os quais houver concorrido, ainda que indiretamente, assim entendidos aqueles decorrentes de eventuais falhas na execução de seus serviços. </p>
	<p class="block_4">&nbsp;</p>
	<p class="block_3"><b class="calibre1">8.</b> O vínculo do <b class="calibre1">CREDENCIADO</b> junto à Rede Mappa vigorará por prazo indeterminado, podendo este ser excluído da Rede, a qualquer momento, a exclusivo critério da <b class="calibre1">HORUS</b>. </p>
	<p class="block_4">&nbsp;</p>
	<p class="block_3"><b class="calibre1">9.</b> O <b class="calibre1">CREDENCIADO</b> obriga-se por si, seus sócios, representantes, procuradores, empregados, subcontratados e demais colaboradores, a manter a confidencialidade das informações divulgadas no âmbito da presente relação, ou que tenham ou venha a ter conhecimento ou acesso em razão do seu cumprimento, não podendo, sob qualquer pretexto, utilizá-las para si, divulgar, revelar, reproduzir ou dar conhecimento a terceiros, independentemente do local ou território, responsabilizando-se pelas perdas, danos, lucros cessantes e demais previsões legais, em caso de descumprimento desta obrigação.</p>
	<p class="block_4">&nbsp;</p>
	<p class="block_3"><b class="calibre1">10.</b> A confidencialidade das informações subsistirá ao término da relação entre <b class="calibre1">HORUS</b> e <b class="calibre1">CREDENCIADO</b>, enquanto nesta condição forem mantidas pela <b class="calibre1">HORUS</b>, obrigando o <b class="calibre1">CREDENCIADO</b>, seus sucessores e representantes a qualquer título.</p>
	<p class="block_4">&nbsp;</p>
	<p class="block_3"><b class="calibre1">11.</b> O <b class="calibre1">CREDENCIADO</b> declara e reconhece, para todos os fins e efeitos, que os direitos sobre a propriedade intelectual relativa às imagens captadas serão de titularidade exclusiva da <b class="calibre1">HORUS</b>, ou de seus respectivos clientes, assim entendidos aqueles relativos à propriedade industrial e ao direito autoral.</p>
	<p class="block_4">&nbsp;</p>
	<p class="block_11"><b class="calibre1">12.</b> No caso de desatenção a esta obrigação, poderá a <b class="calibre1">HORUS</b> ou seus respectivos clientes, incondicionalmente, tomar todas as providências no sentido de reivindicar a verdadeira titularidade e direitos conexos,<b class="calibre1"> </b>sem prejuízo desta cobrar do <b class="calibre1">CREDENCIADO</b> a reparação dos danos que vierem a ser apurados.</p>
	<p class="block_12">&nbsp;</p>
	<p class="block_11"><b class="calibre1">13.</b> Pela execução dos serviços, <b class="calibre1">HORUS</b> pagará ao <b class="calibre1">CREDENCIADO</b> os valores ajustados caso a caso, sendo que o pagamento ocorrerá até o 5º (quinto) dia do mês subsequente ao mês corrente, mediante a apresentação prévia de nota fiscal à <b class="calibre1">HORUS</b>. </p>
	<p class="block_4">&nbsp;</p>
	<p class="block_3"><b class="calibre1">14.</b> Em não ocorrendo o pagamento na forma estipulada no <i class="calibre5">caput</i> desta Cláusula, fica autorizada o <b class="calibre1">CREDENCIADO</b> a cobrar multa de 2% (dois por cento), juros de mora de 1% (um por cento) ao mês e correção monetária pelo INPC/IBGE, calculados <i class="calibre5">pro rata die</i> entre a data de vencimento e a data do efetivo pagamento.</p>
	<p class="block_4">&nbsp;</p>
	<p class="block_3"><b class="calibre1">15. </b>No preço ajustado nesta Cláusula estão inclusos os valores relativos às taxas, impostos, encargos sociais (trabalhistas e previdenciários) ou quaisquer outros tributos concernentes à atividade descrita como objeto desta relação. </p>
	<p class="block_4">&nbsp;</p>
	<p class="block_3"><b class="calibre1">16.</b> Fica desde já reconhecido pelas partes que nenhuma detém exclusividade em relação à outra, podendo, por tanto, o <b class="calibre1">CREDENCIADO</b> prestar seus serviços a quem quer que seja, assim como pode <b class="calibre1">HORUS</b> contratar quem bem entender para realizar a captação das imagens. </p>
	<p class="block_4">&nbsp;</p>
	<p class="block_3"><b class="calibre1">17.</b> As Partes reconhecem e declaram para os fins do art. 10, §2º da Medida Provisória nº 2.200 de 2001, que as suas respectivas assinaturas, apostas no Contrato e nos instrumentos deste decorrentes por intermédio do serviço de assinaturas digital disponível no <a href="https://www.d4sign.com.br/" class="text_">https://www.d4sign.com.br/</a>, são plenamente vinculantes e eficazes, constituindo o Contrato título executivo extrajudicial para todos os fins de direito, admitindo também como válidas e originais as vias do Contrato, assim como dos documentos deste decorrentes, que dispuserem de certificado de autoria e integridade em conformidade com o registro de integridade emitido pelo serviço de assinaturas digital <i class="calibre5">d4sign</i>.</p>
	<p class="block_4">&nbsp;</p>
	<p class="block_13"><b class="calibre1">18. </b>Para dirimir questões oriundas da presente relação as partes, em comum acordo, elegem o foro central da Comarca de Florianópolis, Estado de Santa Catarina, com renúncia expressa a todos os demais, por mais privilegiado que sejam.</p>
	<p class="block_4">&nbsp;</p>

</div>

</body></html>


    </v-container>
  </div>
  
</template>

<script>
  export default {
    name: "AccreditedTermsUse"
  }
</script>

<style scoped lang="scss">
  .bg {
    background-image: url("../../assets/general/bg-neutral.jpg");
    background-size: cover;
  }

  .block_ {
    display: block;
    font-style: italic;
    font-weight: bold;
    line-height: 1.2;
    margin-bottom: 10px;
    margin-left: 0;
    margin-right: 20px;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 20px;
    padding-right: 0px;
    padding-top: 0;
    text-align: left
    }
.block_1 {
    display: block;
    font-family: serif;
    font-size: 0.75em;
    line-height: 1.15;
     margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    padding-bottom: 0;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 0
    }
.block_2 {
    display: block;
    font-family: serif;
    font-size: 0.75em;
    line-height: 1.15;
     margin-left: 20px;
    margin-right: 20px;
    margin-top: 40px;
    padding-bottom: 0;
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 0;
    text-align: right
    }
.block_3 {
    display: block;
    line-height: 1.2;
      margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    text-align: justify
    }
.block_4 {
    display: block;
    font-family: serif;
    font-size: 0.75em;
    line-height: 1.15;
     margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    text-align: justify
    }
.block_5 {
    display: list-item;
    line-height: 1.2;
    margin-bottom: 0;
    margin-left: 36pt;
    padding-bottom: 0;
    padding-top: 0;
    text-align: justify
    }
.block_6 {
    display: list-item;
    line-height: 1.2;
    margin-bottom: 0;
    margin-left: 36pt;
    margin-top: 0;
    padding-bottom: 0;
    padding-top: 0;
    text-align: justify
    }
.block_7 {
    display: list-item;
    line-height: 1.2;
    margin-bottom: 10pt;
    margin-left: 36pt;
    margin-top: 0;
    padding-bottom: 0;
    padding-top: 0;
    text-align: justify
    }
.block_8 {
    display: block;
     margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    text-align: justify
    }
.block_9 {
    display: table-row;
    line-height: 1.2;
      margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    text-align: justify
    }
.block_10 {
    display: table-row;
    line-height: 1.2;
      margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    text-align: justify
    }
.block_11 {
    display: block;
    line-height: 1.2;
     margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    text-align: justify
    }
.block_12 {
    display: block;
    font-family: serif;
    font-size: 0.75em;
    line-height: 1.15;
      margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    text-align: justify
    }
.block_13 {
    display: block;
    line-height: 1.2;
      margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    page-break-inside: avoid;
    text-align: justify
    }
.bullet_ {
    display: table-cell;
    font-weight: bold;
    line-height: 1.2
    }
.calibre {
    color: black;
    display: block;
    font-family: "Verdana", sans-serif;
    font-size: 1em;
    margin-bottom: 0;
    margin-left: 5pt;
    margin-right: 5pt;
    margin-top: 0;
    padding-left: 0;
    padding-right: 0
    }
.calibre1 {
    font-weight: bold;
    line-height: 1.2
    }
.calibre2 {
    font-weight: bold
    }
.calibre3 {
    display: table;
    margin-bottom: 0;
    margin-left: 0;
    margin-right: 20px;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 36pt;
    padding-right: 0;
    padding-top: 0
    }
.calibre4 {
    display: table-cell;
    line-height: 1.2
    }
.calibre5 {
    font-style: italic;
    line-height: 1.2
    }
.list_ {
    display: block;
    list-style-type: upper-roman;
    margin-bottom: 0;
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-right: 0;
    padding-top: 0
    }
.text_ {
    color: #00F;
    line-height: 1.2;
    text-decoration: underline
    }

@page {
    margin-bottom: 5pt;
    margin-top: 5pt
    }



</style>